import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Button from '@mui/material/Button';
import { useModal } from 'mui-modal-provider';
import * as React from 'react';
import { GenericReducer, genericReducer } from '../../../../sic-lib/reducers/genericReducer';
import { resetCommunicatorState, setContacts, setTemplate } from '../../../../store/communicator';
import { useAppDispatch } from '../../../../store/hooks';
import DialogConfirmAction from '../../../Shared/DialogConfirmAction/DialogConfirmAction';
import MenuResetApSchedulerRaw from './MenuResetApSchedulerRaw/MenuResetApSchedulerRaw';

export enum DialogId {
    none = -1,
    contacts = 0,
    template,
    all,
}

interface DialogState {
    dialogId: DialogId;
    title: string;
    description: string;
}

export default function MenuResetApScheduler() {
    const dispatch = useAppDispatch();
    const { showModal } = useModal();

    const [menuId] = React.useState<string>('menu_add_ap_action');

    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

    const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const [dialogState, dialogDispatch] = React.useReducer<GenericReducer<DialogState>>(
        genericReducer,
        {
            dialogId: DialogId.none,
            title: '',
            description: '',
        },
    );

    const handleOpenConfirm = (event: React.MouseEvent<HTMLElement>) => {
        const { dialogId } = event.currentTarget.dataset;

        if (dialogId) {
            switch (+dialogId) {
                case DialogId.contacts:
                    dialogDispatch({
                        dialogId: +dialogId,
                        title: 'Confirm Reset Contacts',
                        description: 'Current contacts will be reset',
                    });
                    break;
                case DialogId.template:
                    dialogDispatch({
                        dialogId: +dialogId,
                        title: 'Confirm Reset Template',
                        description: 'Current Action Plan template will be reset',
                    });
                    break;
                case DialogId.all:
                    dialogDispatch({
                        dialogId: +dialogId,
                        title: 'Confirm Reset',
                        description: 'Current contacts and Action Plan template will be reset',
                    });
                    break;
            }

            const modal = showModal(DialogConfirmAction, {
                title: dialogState.title,
                description: dialogState.description,
                onConfirm: () => {
                    if (dialogState.dialogId === DialogId.contacts) {
                        dispatch(setContacts([]));
                    } else if (dialogState.dialogId === DialogId.template) {
                        dispatch(setTemplate(null));
                    } else if (dialogState.dialogId === DialogId.all) {
                        dispatch(resetCommunicatorState());
                    }

                    dialogDispatch({
                        dialogId: DialogId.none,
                        title: '',
                        description: '',
                    });
                },
                onCancel: () => {
                    modal.hide();
                },
            });
        }

        setAnchorEl(null);
    };

    return (
        <React.Fragment>
            <Button
                aria-haspopup={true}
                aria-expanded={anchorEl !== null}
                aria-controls={menuId}
                onClick={handleOpen}
                endIcon={<ArrowDropDownIcon />}
            >
                Reset
            </Button>
            <MenuResetApSchedulerRaw
                menuId={menuId}
                anchorEl={anchorEl}
                onSelectHandler={handleOpenConfirm}
                onCloseHandler={handleClose}
            />
        </React.Fragment>
    );
}
